import { useContext, useEffect, useState } from "react";
import axios from "axios";
import useApiRequest from '../services/apiRequest';
import { GlobalStateContext } from "../wrappers/GlobalContext";

export default function useFetch(endpoint: string, params?: string, method: 'GET' | 'POST' = 'GET') {
    const { getApimToken} = useApiRequest();

    const { apimToken } = useContext(GlobalStateContext);
    const { baseUrl } = useApiRequest();
    const [data, setData] = useState<any>(null);
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                let response;
                if (method === 'GET') {
                    const url = `${baseUrl}${endpoint}${params || ""}`;
                    response = await axios.get(url, {
                        headers: {
                            'Authorization': `Bearer ${apimToken}`
                        }
                    });
                } else {
                    const url = `${baseUrl}${endpoint}`;
                    response = await axios.request({
                        url,
                        method: "POST",
                        data: JSON.parse(params || ""),
                        headers: {
                            'Authorization': `Bearer ${apimToken}`,
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                        }
                    });
                }
                setData(response.data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        if (apimToken) {
            fetchData();
        }
    }, [apimToken, endpoint, params, method, baseUrl]);

    return { data, error, loading };
}
